import React, { FunctionComponent } from 'react'
import styles from './ObjectDesignPicker.module.sass'
import { DesignStatus, objectStatusToClass, ProjectWorkObject } from '../../../responses/objects'
import { Task } from '../../../responses/tasks'
import DesignStatusPicker, { isTaskIncomplete } from '../DesignStatusPicker/DesignStatusPicker'
import { entityReplace } from '../../../utils/entity-utils'
import ObjectTitle from '../ObjectTitle/ObjectTitle'
import clsx from 'clsx'
import { isNonEmpty } from 'fp-ts/es6/Array'
import { objectDesign, objectProduction } from '../../../utils/lenses'

interface Props {
    object: ProjectWorkObject,
    tasks: Task[],
    objectChange: (object: ProjectWorkObject) => void
    tasksChange: (tasks: Task[]) => void,
    withoutHeader?: boolean,
}

export const isObjectIncomplete = (object: ProjectWorkObject, tasks: Task[]): boolean => (
    isNonEmpty(tasks) ?
        tasks.some(isTaskIncomplete) :
        object.design_status === DesignStatus.NONE
) || object.production_status === DesignStatus.NONE

const ObjectDesignPicker: FunctionComponent<Props> = props => {
    const warning = isObjectIncomplete(props.object, props.tasks)

    return <div>
        {
            !props.withoutHeader && <ObjectTitle
                className={clsx(styles.title, styles[objectStatusToClass(props.object.status_id)])}
                object={props.object}
                arrow={'none'}
            >
                <div className={styles.warning}>{warning && 'Проставьте статус'}</div>
            </ObjectTitle>
        }
        <div className={clsx(styles.content, { [styles.warning]: false })}>
            {
                isNonEmpty(props.tasks) ?
                    props.tasks.map(task => <DesignStatusPicker
                        key={task.id}
                        type={'tender'}
                        task={task}
                        onChange={task => props.tasksChange(entityReplace(task)(props.tasks))}
                    />) :
                    <DesignStatusPicker
                        type={'design'}
                        status={props.object.design_status}
                        onChange={status => props.objectChange(objectDesign.set(status)(props.object))}
                    />
            }
            <DesignStatusPicker
                type={'production'}
                status={props.object.production_status}
                onChange={status => props.objectChange(objectProduction.set(status)(props.object))}
            />
        </div>
    </div>
}

export default ObjectDesignPicker